<template>
  <div class="model-content">
    <div
      class="model_33"
      :class="
        posterList.lang == 'ug' || !posterList.lang ? 'model_ug' : 'model_zh'
      "
    >
      <div class="img-box">
        <img style="width: 100%" :src="url" />
      </div>

      <div class="merchant-name">
        <div class="merchant-name-title">{{ posterList.merchant_name }}</div>
      </div>

      <div class="date">
        <div
          class="date_text"
          v-if="posterList.lang == 'ug' || !posterList.lang"
        >
          تاماقنى مۇلازىمدىن بۇيرۇتسىڭىز تېخىمۇ قولايلىق
        </div>
        <div class="date_text" v-if="posterList.lang == 'zh'">
          方便又快捷就用美滋来
        </div>
      </div>

      <div class="food_name">
        <div class="food_name_text">{{ posterList.food_name }}</div>
      </div>

      <div class="food_img">
        <img class="image" :src="posterList.food_img" alt="" />
        <img class="border" :src="border" alt="" />
      </div>

      <div class="food_img_border"></div>

      <div class="food_price" :style="{ fontSize: posterList.fontSize + 'px' }">
        <span class="number"> {{ posterList.food_price }} </span>
        <span
          v-if="posterList.lang == 'ug'"
          :style="{ fontSize: posterList.fontSize - 4 + 'px' }"
        >
          يۈەن
        </span>
        <span v-if="posterList.lang == 'zh'"> 元 </span>
      </div>

      <div class="old_price">
        <div class="old_price_text" v-if="posterList.lang == 'ug'">
          ئەسلى باھاسى :
        </div>
        <div class="old_price_text" v-if="posterList.lang == 'zh'">原价 :</div>
        <div class="line">
          <span class="number"> {{ posterList.old_price }} </span>
          <span v-if="posterList.lang == 'ug'"> يۈەن </span>
          <span v-if="posterList.lang == 'zh'"> 元 </span>
        </div>
      </div>

      <div class="merchant_qrcode">
        <img :src="posterList.merchant_qrcode" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "model_33",
  data() {
    return {
      posterList: {},
      url: require("../../img/poster/model_33.jpg"),
      border: require("../../img/poster/model_33_border1.png"),
    };
  },
  created() {
    this.canvasfortitle(
      this.$route.query.merchant_name,
      this.$route.query.food_name,
      this.$route.query
    );
  },
  methods: {
    canvasfortitle(merchant_name, food_names, query) {
      let res_name = merchant_name.replaceAll("(", "-");
      res_name = res_name.replaceAll("（", "-");
      res_name = res_name.replaceAll(")", " ");
      res_name = res_name.replaceAll("）", " ");
      let food_name = food_names.replaceAll("(", "-");
      food_name = food_name.replaceAll("（", "-");
      food_name = food_name.replaceAll(")", " ");
      food_name = food_name.replaceAll("）", " ");
      this.posterList = query;
      this.posterList["merchant_name"] = res_name;
      this.posterList["food_name"] = food_name;
      this.posterList.food_price = parseFloat(query.food_price);
      const price = query.food_price.toString();
      let fontSize = 20;
      if (price.length <= 2) {
        fontSize = 30;
      } else if (price.length == 3) {
        fontSize = 28;
      } else if (price.length == 4) {
        fontSize = 24;
      } else if (price.length == 5) {
        fontSize = 23;
      } else if (price.length == 6) {
        fontSize = 20;
      }
      this.posterList.fontSize = fontSize;
    },
  },
};
</script>

<style scoped>
.model-content {
  width: 308px;
  height: 633px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
}

.model_33 {
  width: 308px;
  height: 633px;
  position: relative;
}

.model_ug {
  direction: rtl;
}

.model_zh {
  direction: ltr;
}

.img-box {
  width: 100%;
  height: 100%;
}

.merchant-name {
  position: absolute;
  top: 68px;
  right: 50%;
  transform: translateX(50%);
  color: #fff;
  width: 260px;
  height: 56px;
  padding: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.merchant-name-title {
  font-size: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
}

.date {
  position: absolute;
  top: 150px;
  right: 50%;
  transform: translateX(50%);
  color: #df1419;
  background-color: #fff;
  border-radius: 30px;
  min-width: 266px;
  height: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.food_name {
  position: absolute;
  top: 249px;
  left: -30px;
  transform: rotate(-56deg);
  color: #fff;
  width: 170px;
  height: 56px;
  padding: 10px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-weight: bold;
  text-align: center;
}

.food_name_text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
}

.food_img {
  position: absolute;
  top: 234px;
  left: 50%;
  transform: translateX(-50%);
  width: 280px;
  height: 220px;
  overflow: hidden;
}

.food_img .image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  mask-image: url(../../img/poster/model_33_border.png);
  mask-size: 100% 100%;
  z-index: 2;
}

.food_img .border {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 4;
}

.food_price {
  position: absolute;
  top: 290px;
  right: -20px;
  width: 170px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  transform: rotate(56deg);
}

.food_price .number {
  padding: 0px 4px;
}

.old_price {
  position: absolute;
  top: 470px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  color: #fff;
  display: flex;
  align-items: center;
}

.old_price .line {
  text-decoration: line-through;
  padding-inline: 4px;
}

.merchant_qrcode {
  position: absolute;
  top: 514px;
  left: 33px;
  width: 76px;
  height: 76px;
  background-color: #fff;
  border-radius: 50%;
  overflow: hidden;
  box-sizing: border-box;
}

.merchant_qrcode img {
  width: 100%;
  height: 100%;
}
</style>
